export const fmtEuro0 = (n) =>
  new Intl.NumberFormat("el-GR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 })
    .format(Number(n) || 0);


export const fmtEuro = (n) =>
  new Intl.NumberFormat("el-GR", {
    style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(Number.isFinite(Number(n)) ? Math.round(Number(n)) : 0);

// Κόστη συνταγών: μικρά ποσά χρειάζονται λεπτά (0,40 € αντί για 0 €)
export const fmtEuroCents = (n) => {
  const v = Number(n) || 0;
  return new Intl.NumberFormat("el-GR", {
    style: "currency", currency: "EUR",
    minimumFractionDigits: Math.abs(v) < 100 ? 2 : 0,
    maximumFractionDigits: Math.abs(v) < 100 ? 2 : 0,
  }).format(v);
};


export const fmtNum = (n) =>
  new Intl.NumberFormat("el-GR", { maximumFractionDigits: 0 }).format(Number.isFinite(Number(n)) ? Number(n) : 0);

export const MONTHS_EL = ["", "Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"];
export const MONTHS_EL_SHORT = ["", "Ιαν", "Φεβ", "Μάρ", "Απρ", "Μάι", "Ιούν", "Ιούλ", "Αύγ", "Σεπ", "Οκτ", "Νοέ", "Δεκ"];

export const RUN_TYPE_LABEL = {
  monthly: "Μηνιαία",
  christmas: "Δώρο Χριστουγέννων",
  easter: "Δώρο Πάσχα",
  leave_compensation: "Αποζημείωση Αδείας",
  leave_allowance: "Επίδομα Αδείας",
};

export const ROLE_LABEL = {
  owner: "Ιδιοκτήτης",
  hr: "Προσωπικό / HR",
  manager: "Διευθυντής",
  employee: "Υπάλληλος",
  gardener: "Κηπουρός",
  supplier: "Προμηθευτής",
  maintenance: "Συντήρηση",
  concierge: "Concierge",
  housekeeping: "Housekeeping",
  fnb: "F&B",
  pool_maintainer: "Συντήρηση",
};

export const EXP_STATUS_LABEL = { pending: "Εκκρεμεί", approved: "Εγκρίθηκε", rejected: "Απορρίφθηκε" };
export const RUN_STATUS_LABEL = { draft: "Προσχέδιο", finalized: "Οριστικοποιημένη" };

export const EXPENSE_CATEGORIES = ["Συντήρηση", "Παροχές Πελατών", "Προμήθειες Βίλας", "Φαγητό & Ποτό", "Μεταφορές", "Άλλο"];

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("el-GR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("el-GR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
